import { useAppConfig } from '../contexts/AppConfigContext';
import { Zap } from 'lucide-react';

/**
 * Top strip shown site-wide whenever beta_active===true.
 * Sunset-orange matte, single line, dismissible via next reload only.
 */
export default function BetaBanner() {
    const cfg = useAppConfig();
    if (!cfg.beta_active) return null;
    return (
        <div
            data-testid="beta-top-banner"
            className="w-full bg-[#0D0D0D] border-b border-white/10 text-[#FF6B35]"
        >
            <div className="mx-auto max-w-7xl px-6 py-2 flex items-center gap-3 text-xs sm:text-sm tracking-[0.02em]">
                <span className="inline-flex items-center gap-1.5 uppercase tracking-[0.24em] text-[10px] sm:text-[11px] border border-[#FF6B35]/40 px-2 py-1">
                    <Zap className="h-3 w-3" strokeWidth={2.6} /> Beta v1.0 Mode
                </span>
                <span className="flex-1 text-[#FF6B35]/90">
                    Hello Beta Developers! Help us battle-test the pipeline.
                </span>
                {cfg.beta_slots_available > 0 ? (
                    <span className="hidden sm:inline-block text-[11px] uppercase tracking-[0.22em] text-[#FF6B35]/70">
                        {cfg.beta_slots_available} / {cfg.beta_user_limit} slots left
                    </span>
                ) : (
                    <span className="hidden sm:inline-block text-[11px] uppercase tracking-[0.22em] text-[#FF6B35]/70">
                        Beta full
                    </span>
                )}
            </div>
        </div>
    );
}
